<div [formGroup]="form">
  <div class="card mt-3">
    <div class="card-header">
      <a id="TargetReisedaten"></a>
      <h3>
        <i class="icon-reisedaten"></i> <span i18n>Reisedaten</span>
        <span class="float_right" *ngIf="appConfig.isAssistantAvailable">
          <button type="button" class="btn btn-primary btn-assistent mb-1 me-1" (click)="enableAssistant()"
                  style="width: 170px; background-color: #367297">
            <i class="icon-assistant" style="font-size: 20px; vertical-align: text-bottom"></i>
            <span i18n>Assistent starten</span>
          </button>
        </span>
      </h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header card-header-detail" i18n>Reisedaten und -zweck</div>
            <div class="card-body">

              <div class="row">

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="reisedaten.dvisumAufenthaltszweck"
                           [class.mandatory]="isMandatory('dVisumZweck')"
                           i18n>Zweck des Aufenthalts in Deutschland:</label>
                    <select class="form-select form-select-sm"
                            id="reisedaten.dvisumAufenthaltszweck"
                            [class.is-invalid]="errorClassRequired(form.controls['dVisumZweck'])"
                            formControlName="dVisumZweck"
                            [ngbPopover]="popDVisumZweck"
                            appSaveLastFocussed
                    >
                      <option value="" selected></option>
                      <option *ngFor="let listItem of dVisumReisezweckListItems"
                              value="{{ listItem.key }}">{{ listItem.value }}
                      </option>
                    </select>
                    <ng-template #popDVisumZweck>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte wählen Sie hier den Zweck Ihres geplanten Aufenthalts in Deutschland aus.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>

                <div class="col-md-4" *ngIf="form.value.dVisumZweck === 'Sonstiges'">
                  <div class="mb-3">
                    <label for="reisedaten.dvisumAufenthaltszweckSonstiges"
                           [class.mandatory]="isMandatory('dVisumZweckSonstiges')"
                           i18n>Bitte erläutern:</label>
                    <input id="reisedaten.dvisumAufenthaltszweckSonstiges"
                           type="text"
                           appToUpperCase
                           [attr.maxlength]="getMaxLength('dVisumZweckSonstiges')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['dVisumZweckSonstiges'])"
                           formControlName="dVisumZweckSonstiges"
                           [ngbPopover]="popDVisumZweckSonstiges"
                    >
                    <ng-template #popDVisumZweckSonstiges>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier in lateinischer Schrift auf Deutsch oder Englisch den genauen Aufenthaltszweck ein.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="reisedaten.dvisumErwerbstaetigkeit"
                           [class.mandatory]="isMandatory('dVisumErwerbstaetigkeit')"
                           i18n>Ggf. beabsichtigte Erwerbstätigkeit:</label>
                    <input id="reisedaten.dvisumErwerbstaetigkeit"
                           type="text"
                           appToUpperCase
                           [attr.maxlength]="getMaxLength('dVisumErwerbstaetigkeit')"
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['dVisumErwerbstaetigkeit'])"
                           formControlName="dVisumErwerbstaetigkeit"
                           [ngbPopover]="popDvisumErwerbstaetigkeit"
                    >
                    <ng-template #popDvisumErwerbstaetigkeit>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier in lateinischer Schrift auf Deutsch oder Englisch ein, welche Art von Erwerbstätigkeit Sie in Deutschland ausüben möchten. Falls Sie keine Erwerbstätigkeit planen, können Sie dieses Feld unausgefüllt lassen.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>

              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <span i18n>Beabsichtigte Dauer des Aufenthaltes in Deutschland</span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="mb-3">
                    <label for="visumdaten.gueltigkeit.von"
                           [class.mandatory]="isMandatory('von')"
                           i18n>Von (TT.MM.JJJJ):</label>
                    <div class="input-group" *ngIf="presentationModeEnum.DEFAULT === appConfig.presentationMode">
                      <input angular-mydatepicker
                             id="visumdaten.gueltigkeit.von"
                             #aufenthaltVon="angular-mydatepicker"
                             [options]="datepickerOptions"
                             class="form-control form-control-sm w-50"
                             type="text"
                             [class.is-invalid]="errorClassRequired(form.controls['von'])"
                             appDynamicDateMaxLength
                             formControlName="von"
                             (inputFieldChanged)="onDatePickerInputFieldChanged('von', $event)"
                             (blur)="onDatePickerBlur('von')"
                             [ngbPopover]="popVon"
                             appSaveLastFocussed
                      />
                      <ng-template #popVon>
                        <app-assistant (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte tragen Sie hier ein, ab wann die Einreise beabsichtigt ist.</span>
                        </app-assistant>
                      </ng-template>
                      <span class="input-group-text date-picker" (click)="aufenthaltVon.toggleCalendar()"><i class="icon-calendar"></i></span>
                    </div>
                    <div class="input-group" *ngIf="presentationModeEnum.AP2 === appConfig.presentationMode">
                      <input type="text"
                             class="form-control form-control-sm w-50"
                             value="{{dateFormatter.getFormattedDatePickerValue(form.value.von)}}"
                             disabled
                      />
                      <span class="input-group-text date-picker"><i class="icon-calendar"></i></span>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">


                  <div class="mb-3" *ngIf="!form.value.keine12MonateAufenthalt">
                    <label for="visumdaten.gueltigkeit.bisUngefaehr"
                           [class.mandatory]="isMandatory('bisUngefaehr')"
                           i18n>Bis:</label>
                    <input id="visumdaten.gueltigkeit.bisUngefaehr"
                           type="text"
                           appDynamicDateMaxLength
                           appToUpperCase
                           class="form-control form-control-sm"
                           [class.is-invalid]="errorClassRequired(form.controls['bisUngefaehr'])"
                           formControlName="bisUngefaehr"
                           [ngbPopover]="popBisUngefaehr"
                           appSaveLastFocussed
                    >
                    <ng-template #popBisUngefaehr>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte tragen Sie hier ein, wie lange der/die Antragstellende sich in Deutschland aufhalten möchte. Sollte dies noch nicht genau feststehen oder ist ein Daueraufenthalt geplant, sind auch Textangaben in lateinischer Schrift (Deutsch/Englisch) zulässig.</span>
                      </app-assistant>
                    </ng-template>
                  </div>

                  <div class="mb-3" *ngIf="form.value.keine12MonateAufenthalt">
                    <label for="visumdaten.gueltigkeit.bisGenau"
                           [class.mandatory]="isMandatory('bisGenau')"
                           i18n>Bis (TT.MM.JJJJ):</label>
                    <div class="input-group" *ngIf="presentationModeEnum.DEFAULT === appConfig.presentationMode">
                      <input angular-mydatepicker
                             id="visumdaten.gueltigkeit.bisGenau"
                             #bisGenau="angular-mydatepicker"
                             [options]="datepickerOptions"
                             class="form-control form-control-sm w-50"
                             type="text"
                             [class.is-invalid]="errorClassRequired(form.controls['bisGenau'])"
                             appDynamicDateMaxLength
                             formControlName="bisGenau"
                             (inputFieldChanged)="onDatePickerInputFieldChanged('bisGenau', $event)"
                             (blur)="onDatePickerBlur('bisGenau')"
                             [ngbPopover]="popBisGenau"
                             appSaveLastFocussed
                      />
                      <ng-template #popBisGenau>
                        <app-assistant (assistantDisabled)="disableAssistant()">
                          <span i18n>Bitte tragen Sie hier ein, wie lange der/die Antragstellende sich in Deutschland aufhalten möchte. Sollte dies noch nicht genau feststehen oder ist ein Daueraufenthalt geplant, sind auch Textangaben in lateinischer Schrift (Deutsch/Englisch) zulässig.</span>
                        </app-assistant>
                      </ng-template>
                      <span class="input-group-text date-picker" (click)="bisGenau.toggleCalendar()"><i class="icon-calendar"></i></span>
                    </div>
                    <div class="input-group" *ngIf="presentationModeEnum.AP2 === appConfig.presentationMode">
                      <input type="text"
                             class="form-control form-control-sm w-50"
                             value="{{dateFormatter.getFormattedDatePickerValue(form.value.bisGenau)}}"
                             disabled
                      />
                      <span class="input-group-text date-picker"><i class="icon-calendar"></i></span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <label for="reisedaten.keine12MonateAufenthalt"
                         i18n>Ich beabsichtige, mich nicht länger als zwölf Monate im Bundesgebiet aufzuhalten und beantrage ein Visum mit einer
                    Gültigkeit für den gesamten Aufenthaltszeitraum:</label>
                  <div class="form-check">
                    <input id="reisedaten.keine12MonateAufenthalt"
                           class="mt-2 form-check-input"
                           formControlName="keine12MonateAufenthalt"
                           type="checkbox"
                           [ngbPopover]="popKeine12MonateAufenthalt"
                           appSaveLastFocussed
                    >
                    <span i18n>ja</span>
                    <ng-template #popKeine12MonateAufenthalt>
                      <app-assistant (assistantDisabled)="disableAssistant()">
                        <span i18n>Bitte wählen Sie „ja“ , wenn Sie sicher sind, dass der Aufenthalt nicht länger als 12 Monate betragen wird und das Visum für den gesamten Zeitraum ausgestellt werden soll. In diesem Fall ist bei „bis“ ein konkretes Datum einzugeben.</span>
                      </app-assistant>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
